module.exports = __webpack_public_path__ + "static/img/bg_8.56d8401.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/bg_8.png
// module id = 781
// module chunks = 1